export default "__VITE_ASSET__KznDMdYh__"